var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6189 6.51238L9.82167 1.4314C9.23426 0.856199 8.15734 0.856199 7.56992 1.4314C6.88461 2.00661 6.68881 3.06115 7.27622 3.63636L12.465 9.00494L5.90559 2.19834C5.31818 1.62314 4.14335 1.62314 3.45804 2.19834V2.29421C2.77273 2.96528 2.77273 4.21156 3.45804 4.88264L10.1154 11.4975L4.53496 5.93718C3.84965 5.26611 2.77273 5.26611 2.08741 5.93718C1.3042 6.70412 1.3042 7.85453 2.08741 8.62147L7.96153 14.3735L3.94755 10.443C3.45804 9.96361 2.57692 9.96361 2.08741 10.443C1.5 11.0182 1.5 12.0727 2.08741 12.6479L9.33216 19.7421L13.7377 20.9884C13.7377 20.9884 13.8357 20.9884 13.8357 21.0842L14.9126 22.1388",
    stroke: "#4285F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5699 16.7701L20.6888 15.428L19.6119 5.55361C19.514 4.78667 18.7308 4.21146 17.9475 4.30733C17.1643 4.4032 16.479 5.07427 16.479 5.84121V7.95029C16.2832 8.04616 15.5 8.5255 15.2063 9.48418C14.8147 10.6346 15.3042 11.4974 15.3042 11.6891",
    stroke: "#4285F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7309 15.0016L14.2469 24.2886L17.0159 27.0001L26.5 17.7131L23.7309 15.0016Z",
    stroke: "#4285F4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.749f0f80ef9039e87c5ca249a4361751.svg";
export { ForwardRef as ReactComponent };